import CreateHubspotVerificationKeyMutation from '../../../mutations/CreateHubspotVerificationKeyMutation';
import Util from './util';

export function activateHubspot() {
	const clientId = process.env.HUBSPOT_APP_CLIENT_ID;
	const redirectUri = `${process.env.API_URL}/hubspot/oauth`;
	const scopes = [
		'tickets',
		'crm.objects.contacts.read',
		'crm.objects.contacts.write',
		'crm.objects.companies.write',
		'crm.schemas.contacts.read',
		'crm.objects.companies.read',
		'crm.objects.deals.read',
		'crm.objects.deals.write',
		'crm.schemas.companies.read',
		'crm.schemas.companies.write',
		'crm.schemas.contacts.write',
		'crm.schemas.deals.read',
		'crm.schemas.deals.write',
		'crm.objects.line_items.read',
		'crm.objects.line_items.write',
		'crm.objects.quotes.read',
		'crm.objects.quotes.write',
	];

	const joinedScopes = scopes.join('%20');
	Util.CommitMutation(CreateHubspotVerificationKeyMutation, null, ({createHubspotVerificationKey}) =>
		window.open(
			`https://app.hubspot.com/oauth/authorize?client_id=${clientId}&redirect_uri=${redirectUri}&scope=${joinedScopes}&state=${createHubspotVerificationKey.key}`,
			'_self'
		)
	);
}
